
// src/pages/MS/MIQ101F1.jsx
import React, {useEffect, useState} from 'react';
import style from "./MIQ101F1.module.scss";

import {postData} from "utils/TransactionUtil";
import Modal from "components/Modal/Modal";
import DataGrid from "components/DataGrid/DataGrid";
import Button from "components/Button/Button";
import Icon from "components/Icon/Icon";

import MIQ101F2 from "pages/MI/MIQ101F2";


const ButtonFormatter = ({ row }) => {
    if(row.modInfo) {
        return (
            <button className={style.grid_button} title={row.modInfo}/>
        );
    }
    return null;
};


const MIQ101F1 = ({navBar: NavBar}) => {

    //검색 조건
    const [schUserNm, setSchUserNm] = useState('');

    //사용자리스트
    const [rows_QnaList, setRows_QnaList] = useState([]);
    const cols_QnaList = [
        { key: 'sqnc',           name: 'NO',      width: '5%', renderCell: ({ rowIdx }) => rowIdx+1},
        { key: 'titlNm',         name: '제목',     width: '50%', cellClass: 'align_left' },
        { key: 'qstnRespCtryNm', name: '카테고리',  width: '15%' },
        { key: 'frstRgstDt',     name: '작성일',    width: '20%'},
        { key: 'frstRgsrNm',     name: '작성자명',  width: '10%'},
    ];

    const [qstnRespId, setQstnRespId] = useState();

    const [isModalOpen, setIsModalOpen] = useState(false); //모달 오픈여부(사용자 상세)

    useEffect(() => {

        getQnaList();

    }, []);

    const handleClick_search = () => {
        getQnaList().then(r => {});
    }

    // 검색값 입력후 엔터
    const handleKeyDown_schUserNm = (e) => {
        //e.preventDefault();

        if (e.key === 'Enter') {
            getQnaList().then(r => {});
        }
    };

    async function getQnaList(){
         const param = {
            schUserNm : schUserNm
        }
        const res = await postData("/MIQ/getQnaList", param);
        setRows_QnaList(res);
    }

    //사용자 리스트 더블 클릭
    const handleDblClick_QnaList = (e) => {

        setQstnRespId(e.row.qstnRespId); //QNA Iㅇ
        setIsModalOpen(true);
    }

    //사용자 상세 팝업 닫기
    const handleModal_Close = () => {
        //e.preventDefault();
        setIsModalOpen(false);
    }

    return(
        <main className={style.main_wrap}>
            <NavBar>
                {/*Nav 내용*/}
            </NavBar>
            {/*검색영역*/}
            <div className={style.search_wrap}>
                <span className={style.schTitle}>작성자명</span>
                <input
                    type="text"
                    className={style.schUserNm}
                    defaultValue={schUserNm}
                    onChange={(e) => setSchUserNm(e.target.value)}
                    name="schUserNm"
                    maxLength={'12'}
                    placeholder="작성자명 또는 ID 검색"
                    onKeyDown={(e) => handleKeyDown_schUserNm(e)}
                />
                <Button variant="default" size="md" addStyle={{width: "70px", height: "38px"}}
                        onClick={() => handleClick_search()}>
                    조회<Icon id="rightAngleBrackets_02" width="16" height="16"/>
                </Button>
            </div>
            {/*내용*/}
            <div className={style.main_wrap}>
                <DataGrid
                    cols={cols_QnaList}
                    rows={rows_QnaList}
                    size='md'
                    headerRowHeight={45}
                    rowHeight={30}
                    onCellDoubleClick={(e) => handleDblClick_QnaList(e)}
                    sortable={true}
                    isNodataView={true}
                    isRowColorful={false}
                />
            </div>
            <Modal
                open={isModalOpen}
                handle_Close={handleModal_Close}
                title="Q&A 상세"
                width ="900px"
                height="1500px"
                isHeader={true}
                isBottom={false}>
                <MIQ101F2 handle_Close={handleModal_Close} qstnRespId = {qstnRespId}/>
            </Modal>
        </main>
    )
}
export default MIQ101F1;
